import { CalculatorButton } from "./CalculatorButton";

/**
 * The moment we ask somebody to price the work.
 *
 * One band, one action. It explains what the fee actually moves on, because
 * that is the question people arrive with - then gets out of the way.
 */
export const CalculatorBand = ({
  heading,
  text,
  ctaLabel,
  service,
  slug,
  fineprint = "Indicative only \u2014 the final fee is confirmed once we understand the work. No VAT is added to any T-TITE fee.",
}) => (
  <section
    data-testid={`${slug}-calculator-band`}
    className="relative overflow-hidden border-y border-border bg-[color:var(--tt-teal-mist)]"
  >
    <div className="tt-ruled absolute inset-0 opacity-70" aria-hidden="true" />

    <div className="relative mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between lg:gap-12">
        <div className="max-w-[58ch]">
          <h2 className="text-[27px] font-bold leading-[1.15] tracking-[-0.015em] text-foreground sm:text-[34px]">
            {heading}
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-[color:var(--tt-teal-deep)] sm:text-base">
            {text}
          </p>
          <p className="mt-4 text-[12.5px] leading-relaxed text-muted-foreground">{fineprint}</p>
        </div>

        <CalculatorButton
          service={service}
          testId={`${slug}-band-cta`}
          className="shrink-0 self-start lg:self-auto"
        >
          {ctaLabel}
        </CalculatorButton>
      </div>
    </div>
  </section>
);
